// PrimeReact's Tag only offers 4 severities (success/info/warning/danger),
// one short of the 5 canonical billing statuses - OVERPAID and PARTIAL both
// map to "warning" ("needs a look") since they can't get distinct colors;
// the Tag's own text label (the status name) still disambiguates them.
export const getPaymentSeverity = (
  status: string
): "success" | "info" | "warning" | "danger" => {
  switch (status) {
    case "PAID":
      return "success";
    case "UNPAID":
      return "danger";
    case "PARTIAL":
      return "warning";
    case "WAIVED":
      return "info";
    case "OVERPAID":
      return "warning";
    default:
      return "info";
  }
};
